import objectFitImages from 'object-fit-images';
$(() => objectFitImages());



// WEBPACK FOOTER //
// ./client/app/common/utils/objectFit.js